import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon as faIcon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { click } from 'analytics/utilities';
import { NavLink } from './navLink';

const StyledAccordion = styled(Accordion)(() => ({
  padding: '0px',
  background: 'none',
  boxShadow: 'none',
  transition: 'none',
  '::before': {
    height: '0px',
  },
}));
const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  padding: '0px 12px',
  '&.Mui-expanded': {
    minHeight: '48px',
  },
  '& > .Mui-expanded': {
    margin: '0px !important',
  },
}));

const trackAccordion = (name, expanded) => {
  const trackingName = `sidenav_dropdown_${name}`;
  click(trackingName)({ expanded });
};

export const NavGroup = ({
  links, icon, label, name
}) => (
  <StyledAccordion
    disableGutters
    data-test-id={`sidenav-group__${name}`}
    onChange={(e, expanded) => trackAccordion(name, expanded)}
  >
    <StyledAccordionSummary
      expandIcon={<FontAwesomeIcon icon={faIcon({ name: 'chevron-down' })} />}
    >
      <Box display="flex" alignItems="center" gap="10px">
        <FontAwesomeIcon
          icon={icon}
          style={{
            height: '20px',
            width: '20px',
          }}
        />
        {label}
      </Box>
    </StyledAccordionSummary>
    <AccordionDetails
      sx={{
        paddingTop: '16px',
        marginLeft: '28px',
      }}
    >
      {links.map((link) => (
        <NavLink
          textPath={link.textPath}
          url={link.url}
          displayPath={link.displayPath}
          name={link.name}
          external={link.external}
          visible={link.visible}
        />
      ))}
    </AccordionDetails>
  </StyledAccordion>
);

NavGroup.propTypes = {
  links: PropTypes.array,
  icon: PropTypes.node,
  label: PropTypes.string,
  name: PropTypes.string,
};

NavGroup.defaultProps = {
  links: [],
  icon: null,
  label: '',
  name: '',
};
